import { CometChat } from '@cometchat/chat-sdk-javascript';
import styled from '@emotion/styled';
import useUnreadStore from '../../store/useUnreadStore';
import HomeIcon from '@mui/icons-material/Home';
import { Tooltip, tooltipClasses } from '@mui/material';
import dayjs from 'dayjs';
import { toast } from 'sonner';

export const isUpcomingOrToday = (date) => {
    const givenDate = new Date(date).setHours(0, 0, 0, 0);
    const today = new Date().setHours(0, 0, 0, 0);
    return givenDate >= today;
};
export const handlePreventKeyDown = (event) => {
    const validKeys = ['Backspace', 'Tab', 'ArrowLeft', 'ArrowRight', 'Delete', 'Enter', 'Home', 'End'];
    // Allow Copy (Ctrl+C or Cmd+C), Paste (Ctrl+V or Cmd+V), and Select All (Ctrl+A or Cmd+A)
    if ((event.ctrlKey || event.metaKey) && ['c', 'v', 'a'].includes(event.key.toLowerCase())) {
        return;
    }
    if (validKeys.includes(event.key)) {
        return;
    }

    if (/^[0-9]$/.test(event.key)) {
        if (event.target.value.length >= 12) {
            event.preventDefault();
        }
    } else {
        event.preventDefault();
    }
};

export const paramsToQueryString = (params) => {
    if (params) {
        let queryString = '?';
        Object.keys(params).map((value) => {
            return (queryString += value + '=' + params[value] + '&');
        });
        queryString = queryString.slice(0, -1);
        return queryString;
    }
    return '';
};
export const filterUndefined = (obj) =>
    Object.fromEntries(
        Object.entries(obj)
            .filter(([_, value]) => value !== undefined && value !== null) // Remove undefined and null
            .map(([key, value]) => [
                key,
                value && typeof value === 'object' && !Array.isArray(value)
                    ? filterUndefined(value) // Recursively process nested objects
                    : value,
            ])
    );

export const handlePreventKeyDownDecimal = (event, precision = 2) => {
    if (event.key === 'Enter') {
        event.preventDefault();
        event.stopPropagation();
        return;
    }

    const validKeys = ['Backspace', 'Tab', 'ArrowLeft', 'ArrowRight', 'Delete', 'Home', 'End'];

    if (validKeys.includes(event.key)) {
        return;
    }

    const { value, selectionStart } = event.target;

    if (event.key === '.' && !value.includes('.')) {
        return;
    }

    if (/^[0-9]$/.test(event.key)) {
        const [integerPart, decimalPart] = value.split('.');
        if (decimalPart && selectionStart > value.indexOf('.') && decimalPart.length >= precision) {
            event.preventDefault();
        } else if (integerPart.length >= 12 && (value.indexOf('.') === -1 || selectionStart <= value.indexOf('.'))) {
            event.preventDefault();
        }
    } else {
        event.preventDefault();
    }
};

export const formatNumberWithCommas = (number) => {
    if (!number) return '';
    return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
};

export const parseNumberFromCommas = (numberString) => {
    if (!numberString) return '';
    return numberString.replace(/,/g, '');
};
export const copyToClipboard = (text) => {
    if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard
            .writeText(text)
            .then(() => toast.success('URL copied successfully!'))
            .catch((err) => console.error('Failed to copy: ', err));
    } else {
        const tempInput = document.createElement('input');
        tempInput.value = text;
        document.body.appendChild(tempInput);
        tempInput.select();
        document.execCommand('copy');
        document.body.removeChild(tempInput);
        toast.success('URL copied successfully!');
    }
};
export const PhoneTypeIcon = (type) => {
    if (type === 'home')
        return (
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                <path d="M10 20V14H14V20H19V12H22L12 3L2 12H5V20H10Z" fill="#006CDD" />
            </svg>
        );
    if (type === 'work')
        return (
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="19" viewBox="0 0 20 19" fill="none">
                <path
                    d="M17.5 17.5V3.75H13.75V0H2.5V17.5H0V18.75H8.75V15H11.25V18.75H20V17.5H17.5ZM7.5 12.5H5V10H7.5V12.5ZM7.5 8.75H5V6.25H7.5V8.75ZM7.5 5H5V2.5H7.5V5ZM11.25 12.5H8.75V10H11.25V12.5ZM11.25 8.75H8.75V6.25H11.25V8.75ZM11.25 5H8.75V2.5H11.25V5ZM16.25 12.5H13.75V10H16.25V12.5ZM16.25 8.75H13.75V6.25H16.25V8.75Z"
                    fill="#006CDD"
                />
            </svg>
        );
    if (type === 'landline')
        return (
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                <path
                    d="M17.2559 12.253C17.1599 11.586 16.6449 11.066 15.9819 10.911C13.4049 10.307 12.7589 8.823 12.6499 7.177C12.1929 7.092 11.3799 7 9.99991 7C8.61991 7 7.80691 7.092 7.34991 7.177C7.24091 8.823 6.59491 10.307 4.01791 10.911C3.35491 11.067 2.83991 11.586 2.74391 12.253L2.24691 15.695C2.07191 16.907 2.96191 18 4.19991 18H15.7999C17.0369 18 17.9279 16.907 17.7529 15.695L17.2559 12.253ZM9.99991 15.492C8.60491 15.492 7.47391 14.372 7.47391 12.992C7.47391 11.612 8.60491 10.492 9.99991 10.492C11.3949 10.492 12.5259 11.612 12.5259 12.992C12.5259 14.372 11.3939 15.492 9.99991 15.492ZM19.9499 6C19.9259 4.5 16.1079 2.001 9.99991 2C3.89091 2.001 0.0729066 4.5 0.0499066 6C0.0269066 7.5 0.0709066 9.452 2.58491 9.127C5.52591 8.746 5.34491 7.719 5.34491 6.251C5.34491 5.227 7.73691 4.98 9.99991 4.98C12.2629 4.98 14.6539 5.227 14.6549 6.251C14.6549 7.719 14.4739 8.746 17.4149 9.127C19.9279 9.452 19.9729 7.5 19.9499 6Z"
                    fill="#006CDD"
                />
            </svg>
        );
    if (type === 'mobile')
        return (
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                <g clip-path="url(#clip0_29765_6305)">
                    <path
                        d="M14.004 0H5.996C5.46663 0 4.95894 0.210292 4.58461 0.584615C4.21029 0.958938 4 1.46663 4 1.996V18.003C4 19.106 4.894 20 5.996 20H14.003C14.5325 20 15.0403 19.7897 15.4147 19.4154C15.7892 19.0412 15.9997 18.5335 16 18.004V1.996C16 1.46663 15.7897 0.958938 15.4154 0.584615C15.0411 0.210292 14.5334 0 14.004 0ZM10 19C9.31 19 8.75 18.553 8.75 18C8.75 17.447 9.31 17 10 17C10.69 17 11.25 17.447 11.25 18C11.25 18.553 10.69 19 10 19ZM14 16H6V2H14V16Z"
                        fill="#006CDD"
                    />
                </g>
                <defs>
                    <clipPath id="clip0_29765_6305">
                        <rect width="20" height="20" fill="white" />
                    </clipPath>
                </defs>
            </svg>
        );
};

export const truncateString = (str, maxLength = 30) => {
    if (str?.length <= maxLength) {
        return str;
    }
    return str ? str.slice(0, maxLength) + '...' : '';
};

export const onInvalid = (errors, setFocus) => {
    const firstErrorField = Object.keys(errors)[0];
    if (firstErrorField) {
        const errorElement = document.querySelector(`[name=${firstErrorField}]`);
        if (errorElement) {
            errorElement.scrollIntoView({ behavior: 'smooth' });
            setTimeout(() => {
                const offset = 100; // Adjust the offset value as needed
                const elementPosition = errorElement.getBoundingClientRect().top;
                const offsetPosition = elementPosition - offset;
                window.scrollBy({ top: offsetPosition, behavior: 'smooth' });
                setFocus(firstErrorField);
            }, 0);
        }
    }
};

export const updateObjectAtIndex = (array, newObject, index) => {
    // Check if the index is valid
    if (index < 0 || index >= array.length) {
        return array;
    }

    // Return a new array with the element replaced
    return array.map((item, i) => (i === index ? newObject : item));
};
export const roundToNext15Minutes = (date) => {
    const remainder = 15 - (date.minute() % 15);
    return date.add(remainder, 'minute').second(0);
};

export const formatTireDimension = (value) => {
    // Remove all non-digit characters
    const digitsOnly = value.replace(/\D/g, '');

    // Apply the format: XXX/XX/RXX
    let formattedValue = '';
    if (digitsOnly.length > 0) {
        formattedValue += digitsOnly.slice(0, 3); // First 3 digits
    }
    if (digitsOnly.length > 3) {
        formattedValue += '/' + digitsOnly.slice(3, 5); // Next 2 digits
    }
    if (digitsOnly.length > 5) {
        formattedValue += '/R' + digitsOnly.slice(5, 7); // Last 2 digits
    }

    return formattedValue;
};

export const formatTireDimensionWithCursor = (value, cursorPos) => {
    // Remove all non-digits
    const digits = value.replace(/\D/g, '');

    // Count how many digits are before the cursor
    let digitsBefore = 0;
    for (let i = 0; i < cursorPos && i < value.length; i++) {
        if (/\d/.test(value[i])) {
            digitsBefore++;
        }
    }

    // Format the digits
    let formatted = '';
    if (digits.length <= 3) {
        formatted = digits;
    } else if (digits.length <= 5) {
        formatted = `${digits.slice(0, 3)}/${digits.slice(3)}`;
    } else {
        formatted = `${digits.slice(0, 3)}/${digits.slice(3, 5)}/R${digits.slice(5, 7)}`;
    }

    // Calculate new cursor position
    let newCursor = 0;
    let digitsCount = 0;

    for (let i = 0; i < formatted.length; i++) {
        if (/\d/.test(formatted[i])) {
            digitsCount++;
            if (digitsCount <= digitsBefore) {
                newCursor = i + 1;
            }
        } else {
            // If we're at a separator and haven't exceeded digitsBefore
            if (digitsCount < digitsBefore) {
                newCursor = i + 1;
            }
        }
    }

    return { formatted, newCursor };
};

// Utility function for formatting
export const formatNumberAsWhole = (num) => {
    let number = typeof num === 'string' ? Number(num?.replace(/,/g, '')) : num;
    if (isNaN(number) || number === null || number === undefined) return 0;
    return number % 1 === 0 ? Number(number) : Number(number.toFixed(2));
};

export const isNumberInRange = (value, min, max) => {
    return value >= min && value <= max;
};

export const formatDecimalNumber = (value) => {
    // Convert to number if it's a string
    const number = typeof value === 'string' ? parseFloat(value) : value;

    // If it's not a valid number, return null or handle error
    if (isNaN(number)) return null;

    // Check if decimal part is zero
    // if (number % 1 === 0) {
    return number.toString(); // Return without decimal part
    // } else {
    //   return number.toFixed(2); // Keep two decimal places
    // }
};
/**
 * Detects the multi-tax invoice payload shape (totals.taxesBreakdown[]).
 * Legacy payloads (gst/pst objects only) return false so nothing extra renders.
 */
export const isMultiTaxPayload = (totals) => Array.isArray(totals?.taxesBreakdown) && totals.taxesBreakdown.length > 0;

/**
 * Tax codes applied to an entity (service / item / fee). Falls back to "No Tax".
 */
export const getAppliedTaxNames = (entity) => {
    const applied = (entity?.taxesBreakdown || []).filter((t) => t?.applyTax).map((t) => t.taxCode || t.taxName);
    return applied.length > 0 ? applied : ['No Tax'];
};

/**
 * Formats a number as currency; pre-formatted strings pass through untouched.
 */
export const formatMoney = (value) => (typeof value === 'number' ? `$${value.toFixed(2)}` : value || '$0.00');

export const getContrastFontColor = (hexColor) => {
    // Remove the hash if present and ensure we have a valid hex color
    const color = hexColor.replace('#', '');

    // Handle both 3-digit and 6-digit hex colors
    let r, g, b;
    if (color.length === 3) {
        // Expand 3-digit hex
        r = parseInt(color.charAt(0) + color.charAt(0), 16);
        g = parseInt(color.charAt(1) + color.charAt(1), 16);
        b = parseInt(color.charAt(2) + color.charAt(2), 16);
    } else if (color.length === 6) {
        // Standard 6-digit hex
        r = parseInt(color.substring(0, 2), 16);
        g = parseInt(color.substring(2, 4), 16);
        b = parseInt(color.substring(4, 6), 16);
    } else {
        // Return black as default for invalid input
        console.error('Invalid hex color format');
        return '#000';
    }

    // Calculate luminance using the standard formula
    // This determines how bright a color appears
    const luminance = (0.299 * r + 0.587 * g + 0.114 * b) / 255;

    // Debug the calculation

    // Return black for light backgrounds, white for dark backgrounds
    return luminance > 0.5 ? '#000' : '#fff';
};
export const capitalizeFirstLetter = (input) => {
    if (typeof input !== 'string') {
        input = String(input || '');
    }

    return input.charAt(0).toUpperCase() + input.slice(1);
};
export const truncateToFixed = (value, digits = 2) => {
    const input = typeof value === 'number' ? value.toString() : value;

    if (input === '') return '';

    if (input?.endsWith('.')) return input; // case: "34."

    const match = input?.match(/^(-?\d+)(\.\d{0,2})?/);
    if (!match) return '';

    const [_, intPart, decPart = ''] = match;

    // Handle cases like "34.00" → "34", "34.30" → "34.3"
    const cleanedDecimal = decPart;

    return cleanedDecimal ? intPart + cleanedDecimal : intPart;
};
export const calculateTotalAmount = (qty, cost) => {
    const qtyValue = typeof qty === 'string' ? parseFloat(qty.replace(/,/g, '')) : qty;
    const costValue = typeof cost === 'string' ? parseFloat(cost.replace(/,/g, '')) : cost;
    return Number((qtyValue * costValue).toFixed(2)) || 0;
};
export const roundToFixed = (value, digits = 2) => {
    const num = typeof value === 'string' ? parseFloat(value) : value;
    if (isNaN(num)) return '';
    return Number(num.toFixed(digits)).toString();
};
export const validatePhoneNumber = (number) => {
    const numericValue = number.replace(/\D/g, '');
    return numericValue.length === 10;
};
export const toISOStringUTC = (date) => {
    // Convert the input date to a UTC date
    const startOfDay = dayjs(date).startOf('day');
    // Then set the time to the start of the day (00:00:00) in UTC
    const startOfDateUtc = startOfDay.utc();
    // Return the ISO string representation in UTC
    return startOfDateUtc.toISOString();
};

export const toISOStringUTCEnd = (date) => {
    // Convert the input date to a UTC date
    const startOfDay = dayjs(date).endOf('day');
    // Then set the time to the start of the day (00:00:00) in UTC
    const startOfDateUtc = startOfDay.utc();
    // Return the ISO string representation in UTC
    return startOfDateUtc.toISOString();
};

export const preventDefaultClickFunction = (event) => {
    event.preventDefault();
};

// Helper function to build query string from recordPaymentParams
export const buildQueryStringForRecordPayment = (recordPaymentParams) => {
    let queryString = '?';

    // Add other single value params
    if (recordPaymentParams.searchText) {
        queryString += `&searchText=${encodeURIComponent(recordPaymentParams.searchText)}`;
    }

    if (recordPaymentParams.fromDate) {
        queryString += `&fromDate=${recordPaymentParams.fromDate}`;
    }

    if (recordPaymentParams.toDate) {
        queryString += `&toDate=${recordPaymentParams.toDate}`;
    }

    // Add pagination params
    queryString += `&page=${recordPaymentParams.page}`;
    queryString += `&limit=${recordPaymentParams.limit}`;
    queryString += `&sortBy=${recordPaymentParams.sortBy}`;
    queryString += `&sortType=${recordPaymentParams.sortType}`;

    // Add array params for customer
    if (recordPaymentParams.customer && recordPaymentParams.customer.length > 0) {
        recordPaymentParams.customer.forEach((customerId) => {
            queryString += `&customer=${customerId}`;
        });
    }

    // Add array params for company
    if (recordPaymentParams.company && recordPaymentParams.company.length > 0) {
        recordPaymentParams.company.forEach((companyId) => {
            queryString += `&company=${companyId}`;
        });
    }

    // Add array params for status
    if (recordPaymentParams.status && recordPaymentParams.status.length > 0) {
        recordPaymentParams.status.forEach((status) => {
            queryString += `&status=${status}`;
        });
    }

    // Remove leading '&' if present
    return queryString.startsWith('&') ? queryString.substring(1) : queryString;
};

// Usage example:
// const queryString = buildQueryString(recordPaymentParams);
// const apiUrl = `${baseUrl}/record-payments?${queryString}`;
export const formatNumberDecimaWithoutRoundoff = (value) => {
    if (value === null || value === undefined || value === '') return 0;

    const num = parseFloat(value);
    if (isNaN(num)) return 0;

    // Convert to string and split at decimal point
    const [intPart, decPart = ''] = num.toString().split('.');

    // Keep only first 2 decimal digits (truncate, not round)
    const truncatedStr = decPart ? `${intPart}.${decPart.slice(0, 2)}` : intPart;

    const truncated = parseFloat(truncatedStr);

    // If whole number, return without decimals
    if (Number.isInteger(truncated)) {
        return truncated;
    }

    // Otherwise, return with up to 2 decimals (no rounding)
    return truncated;
};

export const HtmlTooltip = styled(({ className, ...props }) => (
    <Tooltip
        {...props}
        classes={{ popper: className }}
        slotProps={{
            popper: {
                modifiers: [
                    {
                        name: 'offset',
                        options: {
                            offset: [0, -2],
                        },
                    },
                ],
            },
        }}
    />
))(() => ({
    [`& .${tooltipClasses.tooltip}`]: {
        backgroundColor: 'rgba(97, 97, 97, 0.90)',
        boxShadow: '0 4px 24px 0 rgba(0, 0, 0, 0.08)',
        color: 'rgba(255, 255, 255, 0.87);',
        width: 180,
        borderRadius: '12px',
        fontSize: 14,
        fontWeight: 500,
        letterSpacing: '-0.42px',
        padding: '8px',
        lineHeight: '120%',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',

        gap: '0',
    },
    [`& .${tooltipClasses.arrow}`]: {
        color: 'rgba(97, 97, 97, 0.90)', // Same as tooltip background color
    },
}));

export const HtmlTooltipSecondary = styled(({ className, ...props }) => (
    <Tooltip
        {...props}
        classes={{ popper: className }}
        slotProps={{
            popper: {
                modifiers: [
                    {
                        name: 'offset',
                        options: {
                            offset: [0, -2],
                        },
                    },
                ],
            },
        }}
    />
))(() => ({
    [`& .${tooltipClasses.tooltip}`]: {
        backgroundColor: '#DFDFDF',
        boxShadow: '0 4px 24px 0 rgba(0, 0, 0, 0.08)',
        color: 'rgba(0, 0, 0, 0.87);',
        // width: 180,
        borderRadius: '12px',
        fontSize: 14,
        fontWeight: 400,
        letterSpacing: '-0.42px',
        padding: '8px',
        lineHeight: '120%',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',

        gap: '0',
    },
    [`& .${tooltipClasses.arrow}`]: {
        color: '#DFDFDF', // Same as tooltip background color
    },
}));

export const HoverTaxTooltip = styled(({ className, ...props }) => (
    <Tooltip
        {...props}
        classes={{ popper: className }}
        // Let Popper flip top<->bottom automatically when there isn't room,
        // and keep the arrow tracking the anchor's actual x-position
        // (not the tooltip box's center) instead of being force-centered.
        PopperProps={{
            modifiers: [
                { name: 'flip', enabled: true, options: { fallbackPlacements: ['bottom', 'top'] } },
                { name: 'arrow', enabled: true },
                { name: 'preventOverflow', enabled: true, options: { padding: 8 } },
            ],
        }}
    />
))(() => ({
    [`& .${tooltipClasses.tooltip}`]: {
        padding: 0,
        minWidth: 'max-content',
        borderRadius: '8px',
        border: '1px solid rgba(0,0,0,0.10)',
        background: '#FFF',
        boxShadow: '0 4px 24px 0 rgba(0, 0, 0, 0.25)',
        color: '#212121',
    },

    [`& .${tooltipClasses.arrow}`]: {
        color: '#FFF',
    },

    // placement="top" → arrow points DOWN → bottom-right edges of the
    // rotated square are visible
    [`&[data-popper-placement*="top"] .${tooltipClasses.arrow}::before`]: {
        boxShadow: '1px 1px 0 0 rgba(0,0,0,0.10)',
    },

    // placement="bottom" (after a flip) → arrow points UP → top-left
    // edges of the rotated square are visible instead
    [`&[data-popper-placement*="bottom"] .${tooltipClasses.arrow}::before`]: {
        boxShadow: '-1px -1px 0 0 rgba(0,0,0,0.10)',
    },
}));

export const focusTooltipInEnd = (event) => {
    // Move cursor to the end of the input
    const input = event.target;
    setTimeout(() => {
        input.setSelectionRange(input.value.length, input.value.length);
    }, 0);
};

export const calculateAmount = (qty, cost) => {
    return formatNumberDecimaWithoutRoundoff((Math.round(Number(qty) * 100) * Math.round(Number(cost) * 100)) / 100);
};

export const CustomTooltip = styled(({ className, width, ...props }) => (
    <Tooltip
        {...props}
        classes={{ popper: className }}
        placement="top"
        arrow
        slotProps={{
            popper: {
                modifiers: [
                    {
                        name: 'offset',
                        options: {
                            offset: [0, -2],
                        },
                    },
                ],
            },
        }}
    />
))(({ width }) => ({
    [`& .${tooltipClasses.tooltip}`]: {
        backgroundColor: '#F1F1F1',
        border: '1px solid rgba(0, 0, 0, 0.40)',
        borderRadius: '12px',
        boxShadow: '0 2px 4px 0 rgba(0, 0, 0, 0.10)',
        backdropFilter: 'blur(3px)',
        color: '#212121',
        fontFamily: 'Roboto',
        fontSize: '14px',
        fontWeight: 400,
        lineHeight: '140%', // 19.6px
        letterSpacing: '-0.42px',
        padding: '12px 16px',
        width: width || '300px',
        maxWidth: width || '300px',
        whiteSpace: 'pre-line', // Allows line breaks
        wordWrap: 'break-word',
        fontFeatureSettings: "'liga' off, 'clig' off",
    },
    [`& .${tooltipClasses.arrow}`]: {
        color: '#F1F1F1',
        '&::before': {
            border: '1px solid rgba(0, 0, 0, 0.40)',
        },
    },
}));

export const calculateTotalAmountWithoutRoundoff = (qty, cost) => {
    const qtyValue = typeof qty === 'string' ? parseFloat(qty.replace(/,/g, '')) : qty;
    const costValue = typeof cost === 'string' ? parseFloat(cost.replace(/,/g, '')) : cost;
    return qtyValue * costValue || 0;
};

/**
 * Converts a time label string (e.g., "2:30 PM") to minutes since midnight
 * @param {string} timeLabel - Time in format "h:mm A" (e.g., "2:30 PM", "9:00 AM")
 * @returns {number} Minutes since midnight (0-1439)
 */
export const timeLabelToMinutes = (timeLabel) => {
    if (!timeLabel || typeof timeLabel !== 'string') return 0;
    const [time, period] = timeLabel.split(' ');
    const [hours, minutes] = time.split(':');
    let hour = parseInt(hours, 10);
    if (period === 'PM' && hour !== 12) hour += 12;
    if (period === 'AM' && hour === 12) hour = 0;
    return hour * 60 + parseInt(minutes, 10);
};

/**
 * Checks if a selected time is within business hours based on processed slots
 * @param {dayjs.Dayjs} selectedTime - The selected time as a dayjs object
 * @param {Array} processedSlots - Array of processed time slots with timeLabel and endTimeLabel
 * @returns {boolean} True if time is within business hours, false otherwise
 */
export const isTimeWithinBusinessHours = (selectedTime, processedSlots) => {
    if (!processedSlots || processedSlots.length === 0) return true; // If no slots, allow any time

    const firstSlotTime = processedSlots[0]?.timeLabel;
    const lastSlotTime = processedSlots[processedSlots.length - 1]?.endTimeLabel;

    if (!firstSlotTime || !lastSlotTime) return true; // If no valid slots, allow any time

    const firstSlotMinutes = timeLabelToMinutes(firstSlotTime);
    const lastSlotMinutes = timeLabelToMinutes(lastSlotTime);
    const selectedTimeMinutes = selectedTime.hour() * 60 + selectedTime.minute();

    // Check if end time is next day (e.g., 2:30 AM is after 3:30 PM)
    if (lastSlotMinutes < firstSlotMinutes) {
        // Business hours wrap to next day (e.g., 3:30 PM to 2:30 AM)
        // Time is valid if it's >= firstSlot OR <= lastSlot
        return selectedTimeMinutes >= firstSlotMinutes || selectedTimeMinutes <= lastSlotMinutes;
    } else {
        // Business hours are same day (e.g., 9:00 AM to 5:00 PM)
        return selectedTimeMinutes >= firstSlotMinutes && selectedTimeMinutes <= lastSlotMinutes;
    }
};

/**
 * Validates a vehicle object based on required fields.
 *
 * @param {Object} vehicle - The vehicle object to validate.
 * @param {boolean} [isLicensePlateRequired=false] - Whether license plate is required.
 * @returns {boolean} True if the vehicle is valid, false otherwise.
 */
const isUSACountry = (country) => country?.country === 'United States';

/**
 * Formats a postal/zip code the way the Postal Code inputs format it while typing,
 * so a value coming back from the API ('M8Y3L8') matches what a user would type ('M8Y 3L8').
 */
export const formatPostalCode = (value, country) => {
    if (!value) return '';
    if (isUSACountry(country)) return value.replace(/\D/g, '').slice(0, 5);
    const cleaned = value.replace(/\s/g, '').toUpperCase().slice(0, 6);
    return cleaned.length > 3 ? cleaned.slice(0, 3) + ' ' + cleaned.slice(3) : cleaned;
};

/**
 * Validates a postal/zip code on its unformatted length, so the check does not
 * depend on whether the separating space is present.
 */
export const isPostalCodeValid = (value, country) => {
    const bare = (value || '').replace(/\s/g, '');
    return isUSACountry(country) ? bare.length === 5 : bare.length === 6;
};

export const getPostalCodeError = (country) => (isUSACountry(country) ? 'Zip code is required - 5 digits' : 'Postal code is required - 6 digits');

export const validateVehicle = (vehicle, isLicensePlateRequired = false) => {
    if (!vehicle) return false;

    const hasYear = !!(vehicle.year || vehicle.vehicleYear);
    const hasMake = !!(vehicle.vehicleMakeId || vehicle.vehicleMake?._id);
    const hasModel = !!(vehicle.vehicleModelId || vehicle.vehicleModel?._id);

    let hasLicense = true;
    if (isLicensePlateRequired) {
        const licenseNumber = vehicle.licenseNumber || vehicle.license;
        hasLicense = !!licenseNumber;
    }

    return hasYear && hasMake && hasModel && hasLicense;
};

/**
 * Calculate total unread count from CometChat response
 */
export const calculateTotalUnread = (data = {}) => {
    const userCounts = Object.values(data.users || {});
    const groupCounts = Object.values(data.groups || {});

    return [...userCounts, ...groupCounts].reduce((sum, count) => sum + count, 0);
};

/**
 * Fetch unread count from CometChat
 */
export const fetchUnreadCount = async () => {
    try {
        const data = await CometChat.getUnreadMessageCount();
        return calculateTotalUnread(data);
    } catch (error) {
        console.error('Unread count fetch error:', error);
        return 0;
    }
};

/** Refetch global unread total and sync Zustand (use outside `useUnreadCount` where the hook must not mount twice). */
export const refreshUnreadCount = async () => {
    try {
        const count = await fetchUnreadCount();
        useUnreadStore.getState().setUnreadCount(count);
        return count;
    } catch (err) {
        console.error('Unread error:', err);
        return 0;
    }
};

/**
 * Attach unread count listener
 */
export const addUnreadListener = (callback) => {
    const listenerID = 'GLOBAL_UNREAD_LISTENER';

    CometChat.addMessageListener(
        listenerID,
        new CometChat.MessageListener({
            onTextMessageReceived: callback,
            onMediaMessageReceived: callback,
            onCustomMessageReceived: callback,
            onInteractiveMessageReceived: callback,
            onAIAssistantMessageReceived: callback,
            onMessageEdited: callback,
            onMessageDeleted: callback,
            onMessagesRead: callback,
            onMessagesReadByAll: callback,
        })
    );

    return listenerID;
};

/**
 * Remove listener
 */
export const removeUnreadListener = (listenerID) => {
    CometChat.removeMessageListener(listenerID);
};

export function truncateWithEllipsis(text, maxLength = 25) {
    if (!text || text.length <= maxLength) return text;

    // Cut till max length
    let trimmed = text.slice(0, maxLength);

    // Find last space to avoid breaking a word
    let lastSpaceIndex = trimmed.lastIndexOf(' ');

    if (lastSpaceIndex === -1) {
        // No spaces → fallback (rare case: single long word)
        return trimmed + '...';
    }

    return trimmed.slice(0, lastSpaceIndex) + '...';
}
